(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["burn-extreme-bday-benefits"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  var SELECTOR = '.bday-benefits';
  var motionOk = window.matchMedia('(prefers-reduced-motion: no-preference)');

  function reveal(section) {
    section.classList.add('bday-benefits--reveal');

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('bday-benefits--in-view');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.15 });

    observer.observe(section);
  }

  function init() {
    if (!('IntersectionObserver' in window) || !motionOk.matches) return;
    document.querySelectorAll(SELECTOR).forEach(function (section) {
      reveal(section);
    });
  }

  if (document.readyState !== 'loading') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["burn-extreme-bday-compare"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  var SELECTOR = '.bday-compare';
  var motionOk = window.matchMedia('(prefers-reduced-motion: no-preference)');

  function reveal(section) {
    section.classList.add('bday-compare--reveal');

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('bday-compare--in-view');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.15 });

    observer.observe(section);
  }

  function init() {
    if (!('IntersectionObserver' in window) || !motionOk.matches) return;
    document.querySelectorAll(SELECTOR).forEach(function (section) {
      reveal(section);
    });
  }

  if (document.readyState !== 'loading') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["burn-extreme-bday-facts"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  function whenSplide(callback) {
    if (window.Splide) { callback(); return; }
    var tries = 0;
    var timer = setInterval(function () {
      if (window.Splide || tries++ > 50) {
        clearInterval(timer);
        if (window.Splide) callback();
      }
    }, 100);
  }

  function initSection(section) {
    var el = section.querySelector('.bday-facts__slider');
    if (!el) return;
    var multiple = el.querySelectorAll('.splide__slide').length > 1;
    new Splide(el, {
      type: 'slide',
      perPage: 1,
      arrows: false,
      pagination: false,
      drag: multiple
    }).mount();
  }

  function init() {
    document.querySelectorAll('.bday-facts').forEach(function (section) {
      whenSplide(function () { initSection(section); });
    });
  }

  if (document.readyState !== 'loading') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["burn-extreme-bday-flavors"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  var SELECTOR = '.bday-flavors';
  var motionOk = window.matchMedia('(prefers-reduced-motion: no-preference)');

  function reveal(section) {
    section.classList.add('bday-flavors--reveal');

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('bday-flavors--in-view');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.2 });

    observer.observe(section);
  }

  function init() {
    if (!('IntersectionObserver' in window) || !motionOk.matches) return;
    document.querySelectorAll(SELECTOR).forEach(function (section) {
      reveal(section);
    });
  }

  if (document.readyState !== 'loading') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["burn-extreme-bday-stages"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  var SELECTOR = '.bday-stages';
  var motionOk = window.matchMedia('(prefers-reduced-motion: no-preference)');

  function reveal(section) {
    section.classList.add('bday-stages--reveal');

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('bday-stages--in-view');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.15 });

    observer.observe(section);
  }

  function init() {
    if (!('IntersectionObserver' in window) || !motionOk.matches) return;
    document.querySelectorAll(SELECTOR).forEach(function (section) {
      reveal(section);
    });
  }

  if (document.readyState !== 'loading') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["burn-extreme-bday-trust"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  function whenSplide(callback) {
    if (window.Splide) { callback(); return; }
    var tries = 0;
    var timer = setInterval(function () {
      if (window.Splide || tries++ > 50) {
        clearInterval(timer);
        if (window.Splide) callback();
      }
    }, 100);
  }

  function init() {
    document.querySelectorAll('.bday-trust__photos').forEach(function (el) {
      whenSplide(function () {
        new Splide(el, {
          type: 'loop',
          autoWidth: true,
          gap: '1rem',
          arrows: true,
          pagination: true,
          drag: 'free',
          focus: 0,
          omitEnd: true,
          breakpoints: {
            990: { padding: { left: '0.9375rem', right: '0' } }
          }
        }).mount();
      });
    });
  }

  if (document.readyState !== 'loading') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["burn-extreme-bday-videos"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  function whenSplide(callback) {
    if (window.Splide) { callback(); return; }
    var tries = 0;
    var timer = setInterval(function () {
      if (window.Splide || tries++ > 50) {
        clearInterval(timer);
        if (window.Splide) callback();
      }
    }, 100);
  }

  function setupCards(section) {
    var cards = section.querySelectorAll('.bday-videos__card');
    cards.forEach(function (card) {
      var video = card.querySelector('.bday-videos__video');
      var play = card.querySelector('.bday-videos__play');
      if (!video) return;

      function toggle() {
        if (video.paused) { video.play(); } else { video.pause(); }
      }

      if (play) play.addEventListener('click', toggle);
      video.addEventListener('click', toggle);
      video.addEventListener('play', function () { card.classList.add('is-playing'); });
      video.addEventListener('pause', function () { card.classList.remove('is-playing'); });
      video.addEventListener('ended', function () { card.classList.remove('is-playing'); });
    });
  }

  function pauseAll(section) {
    section.querySelectorAll('.bday-videos__video').forEach(function (video) {
      if (!video.paused) video.pause();
    });
  }

  function initSection(section) {
    var el = section.querySelector('.bday-videos__carousel');
    if (!el) { setupCards(section); return; }

    var splide = new Splide(el, {
      type: 'slide',
      perPage: 4,
      gap: '1rem',
      arrows: true,
      pagination: true,
      rewind: true,
      breakpoints: {
        990: { perPage: 1, gap: '1rem', padding: { left: '0.9375rem', right: '3.5rem' } }
      }
    });

    // Pause every video before navigating so audio never overlaps.
    splide.on('move', function () { pauseAll(section); });
    splide.mount();
    setupCards(section);
  }

  function init() {
    document.querySelectorAll('.bday-videos').forEach(function (section) {
      whenSplide(function () { initSection(section); });
    });
  }

  if (document.readyState !== 'loading') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mainbannersplide"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function pad(n) {
      return n < 10 ? '0' + n : '' + n;
    }

    function initCountdowns() {
      var timers = document.querySelectorAll('[data-cb-countdown]');
      Array.prototype.forEach.call(timers, function (timer) {
        if (timer.dataset.cbInit === 'true') return;
        timer.dataset.cbInit = 'true';

        var target = new Date(timer.dataset.cbDate).getTime();
        if (isNaN(target)) return; // invalid date string: leave placeholder

        var dEl = timer.querySelector('[data-cb-days]');
        var hEl = timer.querySelector('[data-cb-hours]');
        var mEl = timer.querySelector('[data-cb-minutes]');
        var sEl = timer.querySelector('[data-cb-seconds]');
        var intervalId = null;

        function tick() {
          var diff = Math.floor((target - Date.now()) / 1000);

          if (diff <= 0) {
            timer.hidden = true; // hide the countdown only
            if (intervalId) clearInterval(intervalId);
            return;
          }

          var days = Math.floor(diff / 86400);
          var hours = Math.floor((diff % 86400) / 3600);
          var minutes = Math.floor((diff % 3600) / 60);
          var seconds = diff % 60;

          if (dEl) dEl.textContent = pad(days);
          if (hEl) hEl.textContent = pad(hours);
          if (mEl) mEl.textContent = pad(minutes);
          if (sEl) sEl.textContent = pad(seconds);
        }

        intervalId = setInterval(tick, 1000);
        tick();
      });
    }

    // Delegated click: survives Splide loop clones, re-renders and editor reloads.
    document.addEventListener('click', function (event) {
      var trigger = event.target && event.target.closest ? event.target.closest('[data-cb-popup-id]') : null;
      if (!trigger) return;

      event.preventDefault();
      var id = (trigger.getAttribute('data-cb-popup-id') || '').trim();

      if (window.postscript && window.postscript.popups && typeof window.postscript.popups.open === 'function') {
        // respectPopupStatus: false so an explicit button click always opens the
        // popup, even if the visitor already saw/dismissed it (Postscript otherwise
        // suppresses it via the _ps_pop cookie / frequency rules).
        window.postscript.popups.open(id, {
          activePopupBehavior: 'ALWAYS_DISMISS',
          respectPopupStatus: false
        });
      } else {
        console.warn('[main-banner] Postscript popups SDK not available (window.postscript). The popup only works on the live storefront with the Postscript app embed enabled.');
      }
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initCountdowns);
    } else {
      initCountdowns();
    }

    // Re-init countdowns when a section is (re)loaded in the theme editor.
    document.addEventListener('shopify:section:load', initCountdowns);
  })();

  } catch(e) { console.error(e); }
})();
})();
